import { NgModule } from '@angular/core';
import { InfoPageComponent } from './info-page.component';
import { CommonModule } from '@angular/common';
import { ActionButtonModule } from '../action-button/action-button.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DefaultLayoutModule } from '../../container-components/default-layout/default-layout.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [InfoPageComponent],
  imports: [
    CommonModule,
    IntrackFeatureModule,
    MatCardModule,
    MatButtonModule,
    ActionButtonModule,
    DefaultLayoutModule,
    SvgIconModule,
  ],
  exports: [InfoPageComponent],
})
export class InfoPageModule {}
